/**
 * The Today hero → Conversations handoff.
 *
 * In-memory rather than router state on purpose: attachments are base64 and
 * routinely multi-megabyte, and history state is serialized (and size-capped)
 * by the browser. A module-level slot survives SPA navigation — which is the
 * whole journey — and is intentionally lost on a hard refresh, exactly like
 * the old router-state read that cleared itself after one use.
 *
 * Write with `setHeroHandoff` immediately before navigating; the destination
 * calls `consumeHeroHandoff()` once, which empties the slot so a re-render or
 * a back/forward can never replay the send.
 */

import type { AssistantChatAttachment } from '@/lib/api/assistant.api'

export interface HeroHandoff {
  ask?: string
  attachments?: AssistantChatAttachment[]
  openPage?: { path: string; title?: string }
}

let pending: HeroHandoff | null = null

export function setHeroHandoff(h: HeroHandoff) {
  pending = h
}

export function consumeHeroHandoff(): HeroHandoff | null {
  const h = pending
  pending = null
  return h
}
